export const SET_SUPPLIER_ASIN_DATA = 'SET_SUPPLIER_ASIN_DATA'
export const SET_SUPPLIER_ASIN_RESULT_DATA = 'SET_SUPPLIER_ASIN_RESULT_DATA'
